import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UiGridResetComponent } from '@pages/generics/grid/grid-reset/grid-reset.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltipModule,
        MatDividerModule,
        MatButtonModule,
    ],
    declarations: [
        UiGridResetComponent,
    ],
    exports: [
        UiGridResetComponent,
    ],
})
export class UiGridResetModule { }
